import { mergeDeep, isFunction } from '@config/utils';

let stateGetterUtils;

export const loadingMap = (state) => {
    return state.data.map.loading;
};

export const getActionMap = (state) => {
    return state.data.map.action;
};

export const getModule = (state) => {
    return state?.data?.module || {};
};

export const getModuleName = (state) => {
    return state.data.module ? state.data.module.name || '' : '';
};

export const getModules = (state) => {
    return state.data.module && state.data.module.portal ? state.data.module.portal : [];
};

export const getTools = (state) => {
    return state.data.tools ? state.data.tools : {};
};

export const getTool = (state, id) => {
    return state.data.tools && state.data.tools[id] ? state.data.tools[id] : null;
};

export const getStateTool = (state, id) => {
    let panels = state.data.panels ?? {};
    let kPanel = Object.keys(panels).find(k=> k==id);
    if(kPanel){
        let panel = panels[kPanel];
        return {
            'id': id,
            'active': panel.active,
            'show': panel.show,
            'acl': panel.acl ? panel.acl['view'] : null
        };
    }

    let tools = state.data.tools ?? {};
    let kTool = Object.keys(tools).find(k=> k==id);
    if(kTool){
        let tool = tools[kTool];
        return {
            'id': id,
            'active': tool.active,
            'show': tool.panel ? tool.panel.show : true,
            'acl': tool.acl ? tool.acl['view'] : null
        };
    }
};

export const getStateTools = (state) => {
    let panels = state.data.panels ?? {};
    let tools = state.data.tools ?? {};
    return [
        ...Object.keys(panels).map(k=>{
                return {
                    'id': k,
                    'active': panels[k].active,
                    'show': panels[k].show,
                    'acl': panels[k].acl ? panels[k].acl['view'] : null
                };
            }),
        ...Object.keys(tools).map(k=>{
                return {
                    'id': k,
                    'active': tools[k].active,
                    'show': tools[k].panel ? tools[k].panel.show : true,
                    'acl': tools[k].acl ? tools[k].acl['view'] : null
                };
            })
    ];
};

export const getAcl = (state = {}, tools = {}, id) => {
    let panels = state.data.panels;
    return (id in tools ? tools[id] : null) ? tools[id].acl : ((id in panels ? panels[id] : null) ? panels[id].acl : {});
};

export const getUrl = (state = {}, tools = {}, id) => {
    let panels = state.data.panels;
    return (id in tools ? tools[id] : null) ? tools[id].url : ((id in panels ? panels[id] : null) ? panels[id].url : {});
};

export const getPanel = (state = {}, tools = {}, id) => {
    let panels = state.data.panels;
    return (id in tools ? tools[id] : null) ? tools[id].panel : ((id in panels ? panels[id] : null) ? panels[id] : {});
};

export const isPanelActive = (data = {}, id) => {
    let tools = isFunction(data) ? data.getTools : data;
    return (id in tools ? tools[id] : null) ? tools[id].active : false;
};

export const isPanelVisible = (data = {}, id) => {
    let tools = isFunction(data) ? data.getTools : data;
    return (id in tools ? tools[id] : null) ? tools[id].panel.show : false;
};

export const getPanelStatus = (state = {}, getters = {}, id) => {
    let panels = state.data.panels;
    let tools = getters.getTools;
    return panels[id] ? panels[id].show : (tools[id] ? tools[id].panel.show : false);
};

export const getPanels = (state = {}, tools = {}) => {
    let panels = state.data.panels;
    return [
        ...Object.keys(panels).map(k=>{
            return mergeDeep(panels[k], {
                'id': k,
                'active': panels[k].active,
                'show': !!panels[k].show,
                'showDefault': panels[k].showDefault,
            });
        }),
        ...Object.keys(tools).map(k=>{
            return mergeDeep(tools[k], {
                'id': k,
                'active': tools[k].active,
                'show': tools[k].panel ? !!tools[k].panel.show : false,
                'showDefault': tools[k].panel ? tools[k].panel.showDefault : undefined
            });
        })
    ];
};

export const getList = (state, getters, id, key = undefined) => {
    let panel = getPanel(state, getters, id);
    let lists = panel.lists || {};
    return key ? (key in lists ? lists[key] : []) : lists;
};

export const isLoadedLists = (state, getters, id) => {
    let lists = getList(state, getters, id);
    return lists.loaded == undefined ? true : lists.loaded;
};

export const getConfig = (state, id) => {
    return state.data.config[id] ? state.data.config[id] : {};
};

export const getProjectionMap = (state) => {
    return state.data.module && state.data.module.map ? state.data.module.map.projection : 'EPSG:4326';
};

export const getProjectionsMap = (state) => {
    return state.data.module && state.data.module.map ? state.data.module.map.projections : [];
};

export const getMapDefinitions = (state) => {
    return state.data.map ? state.data.map : {};
};

export const getConfigMap = (state, rootState = {}) => {
    let defaultConfig = rootState.data && rootState.data.map && rootState.data.map.config ? rootState.data.map.config : {};
    let config = state.data.map.config ? state.data.map.config : {};
    return mergeDeep(defaultConfig, config);
};

stateGetterUtils = {

};

export default stateGetterUtils;